<template>
    <div class="overlay-container">
        <slot></slot>
        <div class="overlay" v-if="show"></div>
    </div>
</template>

<script>
export default {
    name: 'OpacityOverlay',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
.overlay-container {
    position: relative;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    opacity: .6;
    background: $white;
}
</style>
